<template>
  <b-card
    class="shadow-sm h-100"
    body-class="d-flex flex-column"
  >
    <b-card-title class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="18"
          class="mr-2 text-muted"
        />
        Próximos Agendamentos
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="$emit('newAppointment')"
      >
        <feather-icon
          icon="PlusIcon"
          size="14"
          class="mr-1"
        />
        Novo
      </b-button>
    </b-card-title>

    <div
      class="upcoming-appointments flex-grow-1"
      style="max-height: 530px; overflow-y: auto"
    >
      <div
        v-for="appointment in upcomingAppointments"
        :key="appointment.id"
        class="d-flex align-items-center p-2 rounded mb-2 border"
      >
        <div
          class="text-center mr-3"
          style="min-width: 52px"
        >
          <small class="text-muted text-uppercase d-block font-weight-bold">
            {{ appointment.dayName }}
          </small>
          <h3 class="mb-0 font-weight-bolder">
            {{ appointment.day }}
          </h3>
          <small class="text-muted">
            {{ appointment.month }}
          </small>
        </div>

        <b-badge
          variant="light"
          class="mr-3"
          style="width: 1px; height: 40px; padding: 0"
        />

        <div class="flex-grow-1 min-width-0">
          <small class="font-weight-bold d-block text-truncate">
            {{ appointment.client }}
          </small>
          <div class="d-flex align-items-center mt-1 flex-wrap">
            <b-badge
              :variant="appointment.statusVariant"
              class="mr-1 mb-1"
            >
              {{ appointment.status }}
            </b-badge>
            <b-badge
              v-if="appointment.motivo"
              :variant="appointment.motivoVariant"
              class="mb-1"
            >
              {{ appointment.motivo }}
            </b-badge>
          </div>
          <div
            v-if="appointment.time"
            class="d-flex align-items-center mt-1"
          >
            <feather-icon
              icon="ClockIcon"
              size="12"
              class="mr-1 text-muted"
            />
            <small class="text-muted">{{ appointment.time }}</small>
          </div>
        </div>
      </div>

      <div
        v-if="!upcomingAppointments.length"
        class="text-center text-muted py-4"
      >
        Nenhum agendamento próximo
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import agendamentosService from '@/services/agendamentos'
import { getStatusLabel, getStatusBadgeClass, getMotivoLabel, getMotivoBadgeClass } from '../calendar-utils'

const badgeVariantMap = {
  'badge-info': 'info',
  'badge-warning': 'warning',
  'badge-success': 'success',
  'badge-danger': 'danger',
  'badge-secondary': 'secondary',
}

export default {
  components: {
    BCard,
    BCardTitle,
    BButton,
    BBadge,
  },
  data() {
    return {
      proximos: [],
    }
  },
  computed: {
    upcomingAppointments() {
      if (!this.proximos.length) return []

      return this.proximos.map(item => {
        const { dayName, day, month, time } = this.formatDate(item.data_agendamento)
        const statusLabel = getStatusLabel(item.status)
        const statusBadge = getStatusBadgeClass(item.status)
        const motivoLabel = item.motivo ? getMotivoLabel(item.motivo) : null
        const motivoBadge = item.motivo ? getMotivoBadgeClass(item.motivo) : null

        return {
          id: item.id,
          dayName,
          day,
          month,
          client: item.cliente?.nome || 'Cliente',
          time,
          status: statusLabel,
          statusVariant: badgeVariantMap[statusBadge] || 'secondary',
          motivo: motivoLabel,
          motivoVariant: motivoBadge ? (badgeVariantMap[motivoBadge] || 'secondary') : null,
        }
      })
    },
  },
  async created() {
    await this.carregarProximos()
  },
  methods: {
    async carregarProximos() {
      try {
        const atendenteId = localStorage.getItem('executivo_id')
        const params = atendenteId ? { atendente_id: atendenteId } : {}
        const response = await agendamentosService.buscarProximosAgendamentos(params)
        this.proximos = response?.data || response || []
      } catch (error) {
        // console.error('Erro ao carregar próximos agendamentos:', error)
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return { dayName: '', day: '', month: '', time: null }
      const date = new Date(dateStr)
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)

      const isToday = date.toDateString() === today.toDateString()
      const isTomorrow = date.toDateString() === tomorrow.toDateString()

      let dayName
      if (isToday) {
        dayName = 'Hoje'
      } else if (isTomorrow) {
        dayName = 'Amanhã'
      } else {
        dayName = date.toLocaleDateString('pt-BR', { weekday: 'short' })
      }
      const day = date.getDate().toString().padStart(2, '0')
      const month = date.toLocaleDateString('pt-BR', { month: 'short' })
      const time = dateStr.includes('T') ? date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : null

      return { dayName, day, month, time }
    },
  },
}
</script>
